import { format } from "../_date-fns";

import type { DateTimeFormat } from "./date-time-format";

export const HourMinutes = {
	name: "HourMinutes",
	pattern: {
		unicode: "HH:mm",
		g2: "HH:mm",
	},
} as const;

export const HourMinutesSeconds = {
	name: "HourMinutesSeconds",
	pattern: {
		unicode: "HH:mm:ss",
		g2: "HH:mm:ss",
	},
} as const;

export const HourMinutesSecondsMillis = {
	name: "HourMinutesSecondsMillis",
	pattern: {
		unicode: "HH:mm:ss.SSS",
		g2: "HH:mm:ss.SSS",
	},
} as const;

export type ClockTimeFormat = typeof HourMinutes | typeof HourMinutesSeconds | typeof HourMinutesSecondsMillis;

/**
 * TODO STAC-22104 can be defined as DateTimeFormat directly
 */
export function getClockTimeFormat(clockTimeFormatDef: ClockTimeFormat): DateTimeFormat {
	return {
		name: clockTimeFormatDef.name,
		pattern: clockTimeFormatDef.pattern,
		format: (time) => format(time, clockTimeFormatDef.pattern.unicode),
	};
}
